var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-23863119\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FooterSpinneybeck.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/pages/wrappers/FooterSpinneybeck.vue
// module id = 558
// module chunks = 1